function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React from "react";
import SocialMemberBubble from "../containers/SocialMemberBubble";
import classNames from "classnames";
import { last, isFunction } from "lodash";
import { injectIntl } from "react-intl";
import { getCurrentTopic } from "../utils/SocialTopicsUtils";
import Icon from "./Icon";
var linkify = function(inputText) {
    var replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    var replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
    var replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
    var replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
    return replacedText;
};
var _React_Component;
var Activity = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(Activity, _superClass);
    var _super = _createSuper(Activity);
    function Activity(props) {
        _classCallCheck(this, Activity);
        var _this;
        _this = _super.call(this, props);
        _this.handleKeyDown = function(event) {
            if (event.key === "Enter" || event.key === " ") {
                _this._onExpand();
            }
        };
        _this.onAction = function(action) {
            switch(action){
                case "update":
                    _this._onToggleEditMode();
                    break;
                case "delete":
                    _this._onToggleDeleteMode();
                    break;
                default:
                    break;
            }
        };
        // activities can have assets - this is how you render them
        _this.renderAssets = function() {
            var _this_props = _this.props, intl = _this_props.intl, activity = _this_props.activity;
            var isCollapsed = !activity.body;
            var assetCount = (activity.assets ? activity.assets.length : activity.asset_count) || 0;
            return isCollapsed && !!assetCount ? /*#__PURE__*/ React.createElement("div", {
                className: "social-activity__attachments social-activity__attachment--compact icon-clip"
            }, intl.formatMessage({
                id: "social.activities._title_assets_",
                defaultMessage: "Assets: {assetCount}"
            }, {
                assetCount: assetCount
            })) : assetCount ? /*#__PURE__*/ React.createElement("ul", {
                className: "social-activity__attachments"
            }, activity.assets.map(function(asset) {
                var assetCss = classNames("attachment", {
                    "attachment--with-preview": !!asset.tn_path
                });
                var style = asset.tn_path ? {
                    backgroundImage: "url(".concat(asset.tn_path, ")")
                } : {};
                return /*#__PURE__*/ React.createElement("li", {
                    className: assetCss,
                    key: asset.id
                }, /*#__PURE__*/ React.createElement("a", {
                    className: "attachment__link",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    href: asset.path,
                    title: asset.name,
                    style: style
                }, /*#__PURE__*/ React.createElement("span", {
                    className: "attachment__type"
                }, last(asset.name.split("."))), !asset.tn_path && asset.name));
            })) : null;
        };
        _this._onToggleEditMode = function(evnt) {
            if (evnt && evnt.preventDefault) {
                evnt.preventDefault();
            }
            if (isFunction(_this.props.onEdit)) {
                _this.props.onEdit(_this.props.activity);
            }
        };
        _this._onToggleDeleteMode = function(evnt) {
            if (evnt && evnt.preventDefault) {
                evnt.preventDefault();
            }
            if (isFunction(_this.props.onDelete)) {
                _this.props.onDelete(_this.props.activity);
            }
        };
        _this._onExpand = function() {
            if (!_this.props.activity.body && !_this.props.deleted) {
                _this.props.fetchActivity(_this.props.activity, getCurrentTopic());
            }
        };
        _this.state = {
            isEditing: false,
            isLoading: false
        };
        return _this;
    }
    var _proto = Activity.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, intl = _this_props.intl, activity = _this_props.activity, actions = _this_props.actions, deleted = _this_props.deleted, session = _this_props.session, isEditable = _this_props.isEditable;
        var classes = classNames("social-activity", {
            teaser: !activity.body && !deleted,
            deleted: deleted,
            "social-activity--own": activity.owner.id === (session === null || session === void 0 ? void 0 : session.id),
            "social-activity--is_new": activity._is_new
        });
        var bodyClasses = classNames("social-activity__body", {
            teaser: !activity.body && !deleted,
            deleted: deleted
        });
        var userClasses = classNames("social-activity__user", {
            "user-inactive": activity.owner.is_active === false
        });
        var lastUpdate = activity.updated_at ? activity.updated_at : activity.created_at;
        var userTooltip = activity.owner.is_active === false ? intl.formatMessage({
            id: "social.users.inactive_title",
            defaultMessage: "inactive"
        }) : "";
        return /*#__PURE__*/ React.createElement("li", {
            key: activity.id,
            className: classes,
            tabIndex: 0,
            onClick: this._onExpand,
            onKeyDown: this.handleKeyDown,
            "aria-label": this.props.isEditable && intl.formatMessage({
                id: "social.activities.edit_tt",
                defaultMessage: "Edit"
            })
        }, /*#__PURE__*/ React.createElement("div", {
            className: "social-activity__meta"
        }, /*#__PURE__*/ React.createElement("div", {
            className: userClasses,
            title: userTooltip
        }, /*#__PURE__*/ React.createElement(SocialMemberBubble, {
            members: [
                activity.owner
            ]
        }), activity.owner.name), /*#__PURE__*/ React.createElement("div", {
            className: "social-activity__updated"
        }, intl.formatRelative(new Date(lastUpdate * 1000))), /*#__PURE__*/ React.createElement("div", {
            className: "social-activity__actions"
        }, !!activity.body && (actions || []).map(function(action) {
            var classes = classNames("social-activity-action", "social-activity-action--".concat(action), action === "update" && "icon-pen", action === "delete" && "icon-trash-bin");
            return /*#__PURE__*/ React.createElement("button", {
                key: action,
                onClick: function() {
                    return _this.onAction(action);
                },
                className: classes
            }, action === "update" ? /*#__PURE__*/ React.createElement(Icon, {
                name: "edit",
                size: "s"
            }) : null, action === "delete" ? /*#__PURE__*/ React.createElement(Icon, {
                name: "delete",
                size: "s"
            }) : null);
        }))), /*#__PURE__*/ React.createElement("div", {
            className: bodyClasses,
            dangerouslySetInnerHTML: {
                __html: activity.body || activity.teaser || deleted && intl.formatMessage({
                    id: "social.activities.this_msg_has_been_deleted_",
                    defaultMessage: "This message has been deleted"
                })
            }
        }), this.renderAssets());
    };
    return Activity;
}(_React_Component = React.Component);
Activity.displayName = "SocialActivity";
Activity.defaultProps = {
    isEditable: false
};
export default injectIntl(Activity);
